export default function mapProps(obj, map) {
    return Object.keys(obj).reduce((result, key)  => ({
        ...result,
        [key]: map({val: obj[key], key})
    }), {})
}
